import axios from 'axios';
import { API_URL_NEW } from '/src/lib/endpoints';
import { prepareSelectParam, prepareFilterParam } from '/src/lib/queryParams';
import { ALLOWED_QUERY_OPERATOR } from '/src/lib/constants';

const fundingAggregationsApi = {

    getInvestmentAnalytics: async (filterList) => {
        const fields = prepareSelectParam(['investedin_location_id', 'investedin_location_name', 'investedin_location_code', 'deals', 'amount', 'ticket_size_proxy', 'deal_share']);

        const filter = prepareFilterParam([
            ...filterList,

            { key: 'verification_status_filter', value: [3], op: ALLOWED_QUERY_OPERATOR.notEq }
        ]);

        const url = `${API_URL_NEW}/investment-analytics?fields=${fields}&filters=${filter}&sort=amount^:DESC`;
        try {
            const response = await axios.get(url);
            return response.data.data;
        } catch (err) {
            console.error(err)
        }
    }

}

export default fundingAggregationsApi;